import { H1 } from "@saysom/shared"
import Head from "next/head"
import React from "react"
import Body from "../components/body/body"
import GitCommit from "../utils/_git_commit"

const Imprint = () => {
	return (
		<>
			<Head>
				<title>Imprint</title>
			</Head>
			<Body>
				<H1>Imprint</H1>

				<p>
					Transfer- und Gründungsunternehmung SaySom
					<br />
					Birkenwaldstraße 205, 70191, Stuttgart
					<br />
					Telefon: 01743237055
					<br />
					TGU Leitung:
					<br />
					Cornelius Carl
					<br />
					Jan-Niklas Dihlmann
					<br />
					Antonia Pervanidis
					<br />
					cornelius.carl@saysom.app
					<br />
					<br />
					TTI – Technologie-Transfer-Initiative GmbH an der Universität
					Stuttgart (TTI GmbH)
					<br />
					Nobelstraße 15
					<br />
					70569 Stuttgart
					<br />
					Telefon: +49 711 6868749- 0<br />
					Telefax: +49 711 6868749-19
					<br />
					info@tti-stuttgart.de
					<br /> <br />
					Version: {GitCommit.logMessage?.split(" ")[0]}
				</p>
			</Body>
		</>
	)
}

export default Imprint
